
import { merge } from "lodash";
import { prefix } from "../helpers";
import { serialize } from "object-to-formdata"
import { data } from "autoprefixer";
/**
 * This is the reource identifier
 * Everything will be under users.get, users.getAll, users.create, users.createAndSendEmail etc...
 */

const namespace = "profile";
/** Path for agreements list: "agreement" (singular) or "agreements" (plural). Use "agreements" for local Pillars service-profile. */
const agreementPath = (import.meta.env.VITE_PROFILE_AGREEMENTS_PATH || "agreement").replace(/\/$/, "");

const nameSpace = merge({}, {
  get: {
    init: () => [
      `${prefix}/${namespace}/profile/init`
    ],
    getDetails: ({ withIdentity = false, id }) => {
      return [`${prefix}/${namespace}/profile${id ? `/${id}` : ''}?withIdentity=${withIdentity}`]
    },
    getConfiguration: (id) => {
      return [`${prefix}/${namespace}/configuration/${id}?extend=steps,steps.fields`]
    },
    getConfigurationFormFields: (id) => {
      return [`${prefix}/${namespace}/configuration/form/${id}/field`]
    },
    getRoles: () => {
      return [`${prefix}/${namespace}/profile/roles`]
    },
    getRolesComplete: () => {
      return [`${prefix}/${namespace}/profile/roles/complete`]
    },
    getNetwork: () => {
      return [`${prefix}/${namespace}/profile/network`]
    },
    getNetworkDetail: (id) => {
      return [`${prefix}/${namespace}/v2/network/${id}?extend=membership,owner.profile,member.profile`]
    },
    getSupply: (onlyRoot = true) => {
      return [`${prefix}/${namespace}/supply${onlyRoot ? '?onlyRoot=true' : ''}`]
    },
    getOrganizationSupply: () => {
      return [`${prefix}/${namespace}/organization/supply`]
    },
    getSubscribedAgreements: (params = {}) => {
      const qs = new URLSearchParams();
      if (params.all === true || params.all === "true") qs.set("all", "true");
      const suffix = qs.toString() ? `?${qs.toString()}` : "";
      return [`${prefix}/${namespace}/${agreementPath}${suffix}`];
    },
    getAgreementById: (id) => [`${prefix}/${namespace}/agreement/${id}`],
  },
  post: {
    login: (data) => [`${prefix}/${namespace}/login`, data],
    register: (data) => [`${prefix}/${namespace}/profile/register`, data],
    registerWizard: data => [`${prefix}/${namespace}/profile/registerWizard`, data],
    updateAvatar: image => [`${prefix}/${namespace}/profile/avatar`, serialize({ image })],
    insertSkills: (ids) => [`${prefix}/${namespace}/profile/skill`, ids],
    requestAccreditation: (data = {}) => [`${prefix}/${namespace}/profile/accreditation`, data],
    acceptAgreement: (data) => [`${prefix}/${namespace}/agreement/subscribe`, data],
    addSupply: (data) => [`${prefix}/${namespace}/organization/supply`, data],
  },
  put: {
    update: (data) => [`${prefix}/${namespace}/profile`, data],
    updatePassword: ({ id, password }) => [`${prefix}/${namespace}/auth/users/${id}/password`, {
      temporary: false,
      type: 'password',
      value: password
    }],
  },
  delete: {
    removeSkill: (id) => [`${prefix}/profile/profile/skill/${id}`],
    removeSupply: (id) => [`${prefix}/${namespace}/organization/supply/${id}`],
  },
})

export default nameSpace;
